import React, { FC, useState, useMemo } from 'react';
import { Slider } from 'antd';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import './ProgramDurationStep.scss';

interface ProgramDurationStepProps {
  clientName?: string;
  value?: number;
  onChange?: (val: number) => void;
}

// Let’s set the program duration.
export const ProgramDurationStep: FC<ProgramDurationStepProps> = ({ value, onChange }) => {
  const [localDuration, setLocalDuration] = useState<number>(1);
  const duration = value !== undefined ? value : localDuration;

  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();
  const programDurationData = programMasterData?.programDuration;
  const programDurationOptions = programDurationData?.options;

  const options = useMemo(() => {
    return [...(programDurationOptions || [])].sort((a, b) => (a.order || 0) - (b.order || 0));
  }, [programDurationOptions]);

  const { title, subtitle } = programDurationData || {};

  if (isLoading) {
    return <div className="program-duration-step">{'Loading options...'}</div>;
  }

  if (isError || !programDurationData) {
    return <div className="program-duration-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="program-duration-step">
      <h2 className="step-title">{title}</h2>
      <p className="step-subtitle">{subtitle}</p>

      <div className="duration-card">
        <div className="slider-container">
          <Slider
            min={1}
            max={options.length > 0 ? options.length : 12}
            step={1}
            dots={true}
            value={duration}
            onChange={(val) => {
              if (onChange) onChange(val as number);
              setLocalDuration(val as number);
            }}
            tooltip={{ open: false }}
            className="duration-slider"
          />
        </div>

        <div className="duration-labels">
          {options.map((opt, index) => {
            const optValue = index + 1;
            // The design just showed numbers, so we parse out the number or fallback to order
            const labelNum = opt.title?.match(/\d+/)?.[0] || optValue;

            return (
              <div
                key={opt.id}
                className={`duration-label-item ${duration === optValue ? 'active' : ''}`}
                onClick={() => {
                  if (onChange) onChange(optValue);
                  setLocalDuration(optValue);
                }}
              >
                <span className="label-text">{labelNum}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
